import React from 'react'
import './index.css'
interface DrawerProps {
    isOpen?: boolean
    placement?: 'top' | 'bottom'
    className?: string
    onClose?: () => void
    closeable?: boolean
    onOk?: () => void
    header?: boolean
    title?: string
}
const Drawer: React.FC<DrawerProps> = (props) => {
    const {
        isOpen,
        className = '',
        onClose = () => undefined,
        onOk = () => undefined,
        placement = 'bottom',
        header,
        title,
    } = props
    return (
        <div
            className={`wl-drawer ${isOpen ? 'active' : ''}`}
            onClick={() => onClose()}
        >
            <div className='backdrap' />
            <div
                className={`wl-drawer-content ${placement} ${
                    isOpen ? 'active' : ''
                } ${className}`}
            >
                <div
                    className='wrapper'
                    onClick={(e) => {
                        e.stopPropagation()
                    }}
                >
                    {header && (
                        <div className='wrapper-title'>
                            <span className='cancel' onClick={() => onClose()}>
                                取消
                            </span>
                            <span className='subtitle'>{title}</span>
                            <span className='sure' onClick={() => onOk()}>
                                确定
                            </span>
                        </div>
                    )}
                    {props.children}
                </div>
            </div>
        </div>
    )
}

export default Drawer
